import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { AttentionModalComponent } from '@shared/components';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AttentionModalComponent, RktButtonDirective],
})
export class ConfirmModalComponent {
  confirmType: 'warning' | 'error' | 'success' = 'error';

  title = 'Attention';

  text!: string;

  confirmBtnText?: string;

  activeModal = inject(ActiveModal);

  @HostListener('document:keydown.enter')
  onEnterPress() {
    this.activeModal.close(true);
  }
}
